import { render, staticRenderFns } from "./coupon-modal.vue?vue&type=template&id=56ed7782&scoped=true"
import script from "./coupon-modal.vue?vue&type=script&lang=js"
export * from "./coupon-modal.vue?vue&type=script&lang=js"
import style0 from "./coupon-modal.vue?vue&type=style&index=0&id=56ed7782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed7782",
  null
  
)

export default component.exports